<div class="cf_overview_explore_tag-cloud" touchTooltip>
	<div class="cf_overview_explore_tag-cloud-svg-empty" *ngIf="!hasData">
		<div class="cf_overview_explore_tag-cloud-svg-empty-text">
			{{ Loc(LocalizedTextIds.TagCloudNoCompanies) }}
		</div>
	</div>
	<svg id="{{ svgId }}" class="cf_overview_explore_tag-cloud-svg"></svg>
</div>
